import { render } from "./AllClubNews.vue?vue&type=template&id=7fd954aa"
import script from "./AllClubNews.vue?vue&type=script&lang=js"
export * from "./AllClubNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__